<template>
  <div>
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div style="height: calc(100vh - 46px); width: 100vw; overflow-y: scroll; -webkit-overflow-scrolling: touch;">
      <!-- <iframe style="height: 100%; width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe> -->
      <iframe style="height: 100%; width: 100%;"
              ref="iframe" frameborder="0"  id="iframe"></iframe>

    </div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;

      // that.getservicerurl();
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
          console.log(that.url)
          this.$nextTick(() => {
            that.$refs.iframe.contentWindow.location.replace(that.url);
          })

        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    this.$nextTick(() => {
      this.url='https://t.me/s6top'
      this.$refs.iframe.contentWindow.location.replace(this.url);
    })
  },
};
</script>

<style lang="scss">
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
iframe {
  max-width: 100vw;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue